import BaseInputTemplate from '@rjsf/core/lib/components/templates/BaseInputTemplate'
import { ArrayFieldTemplateItemType, ArrayFieldTemplateProps, BaseInputTemplateProps, ObjectFieldTemplateProps } from '@rjsf/utils'
import classNames from 'classnames'
import React from 'react'

export const CustomObjectFieldTemplate = (props: ObjectFieldTemplateProps) => {
  return (
    <>
      {props.properties.map((element) => (
        <React.Fragment key={element.name}>{element.content}</React.Fragment>
      ))}
    </>
  )
}

export const CustomArrayFieldTemplate = (props: ArrayFieldTemplateProps) => {
  return (
    <>
      {props.items.map((element) => (
        <React.Fragment key={element.key}>{element.children}</React.Fragment>
      ))}
    </>
  )
}

export const CustomArrayFieldItemTemplate = (props: ArrayFieldTemplateItemType) => {
  return props.children
}

export const CustomBaseInputTemplate = (props: BaseInputTemplateProps) => {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault()
    }
  }

  return (
    <BaseInputTemplate
      {...props}
      className={classNames('form-control', { 'disabled-contact-information-field border-0': props.disabled })}
      placeholder='Not set'
      onKeyDown={handleKeyDown}
    />
  )
}
